module.exports = __webpack_public_path__ + "static/media/ringobass-tara.eef02830.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ringobass-tara.jpg
// module id = ./src/img/ringobass-tara.jpg
// module chunks = 0